export const SET_PENDING = 'EMAILING/SET_PENDING';
export const SET_ADDRESSES = 'EMAILING/SET_ADDRESSES';
export const SET_FAVORITE_ADDRESSES = 'EMAILING/SET_FAVORITE_ADDRESSES';
export const SET_DATA = 'EMAILING/SET_DATA';
export const SET_TEMPLATES = 'EMAILING/TEMPLATES';
